import React from 'react';
import { useWindowSize } from 'common/hooks';
import { optimizeContentfulImageUrl } from 'common/components';

export default function HomepageImage({ field, mobile, style, className }) {
  const { isMobile } = useWindowSize();
  const image = isMobile && mobile ? mobile : field;

  if (!image) return null;

  return (
    <img
      src={optimizeContentfulImageUrl(
        image.fields.file.url,
        image.fields.file.contentType
      )}
      alt={image.fields.title}
      style={style}
      className={className}
    />
  );
}
